export const GET_PREVIEW_PAYROLL = "GET_PREVIEW_PAYROLL";
export const GET_PAYROLL = "GET_PAYROLL";
export const GET_PREVIEW_SPECIAL_PAYROLL = "GET_PREVIEW_SPECIAL_PAYROLL";
export const GET_SPECIAL_PAYROLL = "GET_SPECIAL_PAYROLL";
export const GET_SPECIAL_LIST_DROPDOWN = "GET_SPECIAL_LIST_DROPDOWN";
export const GET_PAYROLL_APPROVAL = "GET_PAYROLL_APPROVAL";
export const FIND_PAYROLL_APPROVAL = "FIND_PAYROLL_APPROVAL";
export const GET_RUN_PAYSLIP = "GET_RUN_PAYSLIP";
export const GET_RUN_PAYSLIP_DETAIL = "GET_RUN_PAYSLIP_DETAIL";
export const GET_PAYROLL_TYPE_LAYOUT = "GET_PAYROLL_TYPE_LAYOUT";

//SETTING
export const FIND_POSITION = "FIND_POSITION";
export const GET_POSITION = "GET_POSITION";
export const GET_POSITION_PERMISSION = "GET_POSITION_PERMISSION";

export const FIND_DEPARTMENT = "FIND_DEPARTMENT";
export const GET_DEPARTMENT = "GET_DEPARTMENT";
export const GET_DEPARTMENT_PERMISSION = "GET_DEPARTMENT_PERMISSION";

export const FIND_COSTCENTER = "FIND_COSTCENTER";
export const GET_COSTCENTER = "GET_COSTCENTER";
export const GET_COSTCENTER_PERMISSION = "GET_COSTCENTER_PERMISSION";

export const GET_INFINITE_EMPLOYEES = "GET_INFINITE_EMPLOYEES";
export const FIND_EMPLOYEE = "FIND_EMPLOYEE";
export const FIND_EMPLOYEE_HISTORY = "FIND_EMPLOYEE_HISTORY";
export const GET_EMPLOYEES = "GET_EMPLOYEE";
export const GET_EMPLOYEE_STATUS = "GET_EMPLOYEE_STATUS";

export const AUTH_USER = "AUTH_USER";
export const GET_USER = "GET_USER";
export const FIND_USER = "FIND_USER";

export const FIND_PAYROLL_TYPE = "FIND_PAYROLL_TYPE";
export const GET_PAYROLL_TYPE = "GET_PAYROLL_TYPE";

export const GET_MODULE_TYPE = "GET_MODULE_TYPE";

export const GET_SYSTEM_ROLE = "GET_SYSTEM_ROLE";
export const FIND_SYSTEM_ROLE = "FIND_SYSTEM_ROLE";

export const FIND_PAYROLL_GROUP = "FIND_PAYROLL_GROUP";
export const GET_PAYROLL_GROUP = "GET_PAYROLL_GROUP";
export const GET_PAYROLL_GROUP_PERMISSION = "GET_PAYROLL_GROUP_PERMISSION";

export const FIND_EXHANGE_RATE = "FIND_EXHANGE_RATE";

//REPORT
export const GET_PROVIDENT_FUND_REPORT = "GET_PROVIDENT_FUND_REPORT";
export const GET_PAYROLL_RECONCILIATION_REPORT = "GET_PAYROLL_RECONCILIATION_REPORT";
export const GET_PAYSLIP_LIST_REPORT = "GET_PAYSLIP_LIST_REPORT";
export const GET_PAYSLIP_LIST_DETAIL_REPORT = "GET_PAYSLIP_LIST_DETAIL_REPORT";
export const GET_MULTI_REPORT = "GET_MULTI_REPORT";
export const GET_MULTI_REPORT_EXCEL_FILE = "GET_MULTI_REPORT_EXCEL_FILE";
export const GET_PROVIDENT_REPORT_EXCEL_FILE = "GET_PROVIDENT_REPORT_EXCEL_FILE";
export const GET_PAYROLL_JOURNAL_REPORT = "GET_PAYROLL_JOURNAL_REPORT";
export const GET_PAYROLL_REPORT = "GET_PAYROLL_REPORT";

//REPOR RECONCILIATION
export const GET_NEW_EMPLOYEE_LIST = "GET_NEW_EMPLOYEE_LIST";
export const GET_RESIGN_EMPLOYEE_LIST = "GET_RESIGN_EMPLOYEE_LIST";
export const GET_TEMPORARY_EMPLOYEE_LIST = "GET_TEMPORARY_EMPLOYEE_LIST";
export const GET_INTERNAL_MOVEMENT_LIST = "GET_INTERNAL_MOVEMENT_LIST";
export const GET_OTHER_BENEFITS_LIST = "GET_OTHER_BENEFITS_LIST";
export const GET_COMPANY_LOAN_LIST = "GET_COMPANY_LOAN_LIST";
export const GET_SUMMARY_LIST = "GET_SUMMARY_LIST";
export const GET_HEAD_COUNT_EMPLOYEE = "GET_HEAD_COUNT_EMPLOYEE";

//ZONE
export const GET_ZONES = "GET_ZONES"
export const FIND_ZONE = "FIND_ZONE"

//REASON
export const GET_REASONS = "GET_REASONS"
export const FIND_REASON = "FIND_REASON"

//COMPANY
export const GET_COMPANY = "GET_COMPANY"
export const FIND_COMPANY = "FIND_COMPANY"

//QUESTION
export const GET_QUESTION = "GET_QUESTION"

//READINESS QUESTION
export const GET_READINESS_QUESTION = "GET_READINESS_QUESTION"
export const FIND_READINESS_QUESTION = "FIND_READINESS_QUESTION"
export const GET_READINESS_DROPDOWN = "GET_READINESS_DROPDOWN"
export const GET_QUESTION_TYPE_DROPDOWN = "GET_QUESTION_TYPE_DROPDOWN"


//FORM
export const GET_FORM = "GET_FORM"
export const FIND_FORM = "FIND_FORM"

//Dropdown
export const GET_FORM_TYPE_LIST = "GET_FORM_TYPE_LIST"
export const GET_ZONE_LIST = "GET_ZONE_LIST"
export const GET_USER_LIST = "GET_USER_LIST"
export const GET_FORM_DROPDOWN = "GET_FORM_DROPDOWN"
export const GET_USERS_DROPDOWN = "GET_USERS_DROPDOWN"
export const GET_FORM_GROUP_LIST = "GET_FORM_GROUP_LIST"
export const GET_REASON_TYPE_LIST = "GET_REASON_TYPE_LIST"

// FORM GROUP
export const GET_FORM_GROUP = "GET_FORM_GROUP";
export const FIND_FORM_GROUP = "FIND_FORM_GROUP";